import { useStyles } from './styles'

export const Logo = () => {
  const { classes } = useStyles({})
  return (
    <div className={classes.root}>
      <img
        src="/assets/webp/logo/gamed.webp"
        alt="logo"
      />
    </div>
  )
}
